import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Divider, Grid, Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import useLanguage from "../../hooks/useLanguage";

export const ArticlePaperFooter = ({ saveSnippet, source, articleID }) => {
  const [text, setText] = useState("");
  const [url, setURL] = useState("");
  const { language } = useLanguage();
  const { translate } = language;
  useEffect(() => {
    setURL(source && source.url ? source.url : "");
  }, [source]);

  const cleanFields = () => {
    setText("");
    setURL("");
  };

  const submit = () => {
    if (text) {
      saveSnippet({ text, source: { ...source, url } }, articleID);
    } else {
      if (text) {
        saveSnippet(
          { text, source: { ...source, name: "Eigenes", url } },
          articleID
        );
      }
    }
    cleanFields();
  };

  return (
    <ArticlePaperFooterContainer>
      <Divider />
      <form>
        <Grid container>
          <Grid item lg={12} md={12}>
            <BorderLessTextArea
              className="text-area-borderless"
              required
              name="text"
              placeholder={translate.custom_snippet_placeholder}
              onChange={(e) => setText(e.target.value)}
              value={text}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} justify="center" alignItems="center">
          <Grid item md={10} lg={10}>
            <InputUrl
              name="url"
              className="input-url"
              placeholder="URL"
              onChange={(e) => setURL(e.target.value)}
              value={url}
            />
          </Grid>
          <Grid item md={2} lg={2}>
            <Button
              color="primary"
              variant="contained"
              onClick={submit}
              className="icon-button"
            >
              <AddIcon />
            </Button>
          </Grid>
        </Grid>
      </form>
    </ArticlePaperFooterContainer>
  );
};

export const ArticlePaperFooterContainer = styled.div`
  position: absolute;
  width: 95%;
  bottom: 0;
  margin-bottom: 10px;
`;

export const InputUrl = styled.input`
  border-width: 2px;
  border-style: dashed;
  border-color: #cdd1da;
  padding: 4px;
  display: inline-block;
  border-radius: 8px;
  font-size: 14px;
  width: 100%;
`;

export const BorderLessTextArea = styled.textarea`
  border: none;
  width: 100%;
`;
